module.exports = __webpack_public_path__ + "img/quality.1a8da09.jpg";